import React from 'react';
import { Countdown, Button, TrustBar } from './Shared';
import { Facebook, Instagram, Youtube } from 'lucide-react';
export function CtaAndFooter() {
  return <>
      {/* SECCIÓN 11: CTA FINAL */}
      <section className="py-16 px-4 bg-brand-deep text-center text-white relative overflow-hidden" data-id="element-11">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[500px] h-[300px] bg-brand-blue/40 rounded-full blur-[120px] pointer-events-none" data-id="element-12"></div>
        <div className="max-w-3xl mx-auto relative z-10" data-id="element-13">
          <p className="text-2xl md:text-3xl font-display font-bold mb-8 leading-tight" data-id="element-14">
            El próximo domingo podés seguir buscando materiales que no se
            adaptan al EBI.
            <span className="block mt-3 text-brand-orange" data-id="element-15">
              O tener todo resuelto desde hoy.
            </span>
          </p>

          <div className="bg-white/10 border border-white/15 rounded-2xl p-6 mb-8" data-id="element-16">
            <Countdown data-id="element-17" />
            <p className="text-brand-sky font-medium mt-4" data-id="element-18">
              Después vuelve a su precio real y no vuelve esta oferta.
            </p>
          </div>

          <div className="max-w-md mx-auto mb-8" data-id="element-19">
            <Button className="py-5 text-xl" data-id="element-20">
              🟠 ELEGÍ TU AULA DE ÉXITOS →
            </Button>
            <div className="mt-6 text-brand-sky" data-id="element-21">
              <TrustBar data-id="element-22" />
            </div>
          </div>

          <div className="font-bold text-brand-orange" data-id="element-23">
            +500 docentes ya lo usan
          </div>
        </div>
      </section>

      {/* SECCIÓN 12: FOOTER */}
      <footer className="bg-brand-deep text-brand-sky py-12 px-4 text-center border-t border-white/10" data-id="element-24">
        <div className="max-w-4xl mx-auto" data-id="element-25">
          <div className="text-2xl font-bold text-white mb-4" data-id="element-26">
            🌟 Tu Fénix Digital
          </div>
          <p className="text-lg mb-8 max-w-md mx-auto" data-id="element-27">
            Porque enseñar no debería costarte todos los domingos del año.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8" data-id="element-28">
            <a href="#" className="hover:text-white transition-colors" data-id="element-29">
              www.tufenixdigital.store
            </a>
          </div>

          <div className="flex justify-center gap-6 mb-8" data-id="element-30">
            <a href="#" className="hover:text-white transition-colors" data-id="element-31">
              <Facebook className="w-6 h-6" data-id="element-32" />
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-33">
              <Instagram className="w-6 h-6" data-id="element-34" />
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-35">
              <Youtube className="w-6 h-6" data-id="element-36" />
            </a>
          </div>

          <div className="text-sm" data-id="element-37">
            © 2026 Tu Fénix Digital — Todos los derechos reservados
          </div>
        </div>
      </footer>
    </>;
}